export default __webpack_public_path__ + "static/media/cl04.70b6fe5a.jpg";